import { createSlice } from '@reduxjs/toolkit';
import { getCareers } from '~store/careers/thunks';

const initialState = {
  careers: [],
  status: {
    careers: 'idle',
    loadMoreProducts: 'idle',
  },
};

const careersSlice = createSlice({
  name: 'careers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCareers.pending, (state, action) => {
        state.status.careers = 'loading';
      })
      .addCase(getCareers.rejected, (state, action) => {
        state.status.careers = 'error';
      })
      .addCase(getCareers.fulfilled, (state, { payload }) => {
        state.careers = payload;
        state.status.careers = 'finished';
      });
  },
});

export default careersSlice.reducer;
